<template>
    <component
        :is="link && user ? 'router-link' : 'div'"
        :to="user ? { name: user.is_operator ? 'operators.show' : 'clients.show', params: { id: user.id } } : {}"
        class="gravatar-container text-decoration-none"
        :class="{
            'gravatar-container-small': small,
        }"
    >
        <div
            v-if="user === null && !email"
            class="avatar-badge client-badge"
            v-text="'?'"
        />
        <div
            v-else
            :class="{
                'external-badge': external && (!user || user.is_operator < 1),
                'client-badge': !external && (!user || user.is_operator < 1),
            }"
            class="avatar-badge"
            v-text="user ? (user.acronym != null ? user.acronym : acronym) : email.slice(0, 2).toUpperCase()"
        />
    </component>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            default () {
                return null;
            },
        },
        email: {
            type: String,
            default: '',
        },
        gravatar: {
            type: String,
            default: '',
        },
        external: {
            type: Boolean,
            default: false,
        },
        link: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            isError: false,
        };
    },
    computed: {
        image () {
            if (this.user != null) {
                return this.user.gravatar;
            } else if (this.gravatar) {
                return this.gravatar;
            } else {
                return '';
            }
        },
        acronym () {
            if (this.user != null) {
                return (this.user.first_name ? this.user.first_name.slice(0, 1).toUpperCase() : '') + (this.user.last_name ? this.user.last_name.slice(0, 1).toUpperCase() : '');
            } else {
                return '?';
            }
        },
    },
    methods: {
        onError () {
            this.isError = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.gravatar-container {
    width: 32px;
    height: 32px;
    margin: 0 .5rem;
}

div.gravatar-container {
    cursor: default;
}

.gravatar-container-small {
    width: initial;
    height: initial;
    display:inline-block;
    vertical-align: top;

    .avatar-badge {
        border-radius: 100%;
        color: #ffffff;
        display: block;
        font-family: sans-serif;
        font-size: 10px;
        font-weight: 600;
        height: 24px;
        width: 24px;
        line-height: 24px;
        text-align: center;
        overflow: hidden;
        border: 1px solid white;
         img{width:100%}
    }

    .profile-image {
        height: 24px;
        width: 24px;
    }
}

.profile-image {
    border-radius: 50%;
    width: 100%;
}

.avatar-badge {
    width: 32px;
    height: 32px;
    position: relative;
    border-radius: 50%;
    font-size: 1rem;
    line-height: 32px;
    font-weight: bold;
    text-align: center;
    z-index: 100;
}
</style>
